import React from 'react';

const SvgGt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="GT_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GT_svg__b" fill="#fff">
        <use xlinkHref="#GT_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#63AEE3"
        mask="url(#GT_svg__b)"
        d="M18.667 0H28v20h-9.333zM0 0h9.333v20H0z"
      />
      <path
        d="M11.333 9.333c0 .986.535 1.847 1.33 2.308m2.772-.06a2.665 2.665 0 0 0 1.232-2.248"
        stroke="#628A40"
        strokeWidth={1.333}
        strokeLinecap="round"
        mask="url(#GT_svg__b)"
      />
      <circle
        fill="#DCC26D"
        mask="url(#GT_svg__b)"
        cx={14}
        cy={9.333}
        r={1.333}
      />
    </g>
  </svg>
);

export default SvgGt;
